import { render, staticRenderFns } from "./Assinatura.vue?vue&type=template&id=7d3da154&"
import script from "./Assinatura.vue?vue&type=script&lang=js&"
export * from "./Assinatura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VExpandTransition})
